import React from 'react';
import { Link } from 'react-router-dom';
import { articles as initialArticles } from '../data/articles';
import { useScrollReveal } from '../hooks/useScrollReveal';
import './Blog.css';

export default function Blog({ articles = initialArticles }) {
  // Show first 3 highlighted articles on the homepage
  const featuredArticles = articles.slice(0, 3);
  const cardRefs = useScrollReveal(featuredArticles.length);

  return (
    <section className="blog-section" id="blog">
      <div className="container">
        <div className="section-header text-center">
          <span className="badge-volt">ILTG NEWSFEED</span>
          <h2 className="section-title">THE PERFORMANCE INSIGHTS BLOG</h2>
          <p className="section-subtitle">
            Stay informed with the latest updates on soccer tech analysis, coaching tutorials, and Canadian league profiles.
          </p>
        </div>

        <div className="blog-grid">
          {featuredArticles.map((article, idx) => (
            <article 
              key={article.id} 
              className="card-tech blog-card"
              ref={(el) => (cardRefs.current[idx] = el)}
            >
              {article.heroImage && (
                <div className="blog-card-image-wrap">
                  <Link to={`/blog/${article.id}`}>
                    <img src={article.heroImage} alt={article.heroImageAlt || `Playermaker Canada, ${article.title}`} className="blog-card-image" width="400" height="250" loading="lazy" />
                  </Link>
                </div>
              )}
              <div className="blog-card-content">
                <div className="blog-meta">
                  <span className="blog-category">{article.category}</span>
                  <span className="blog-read-time">{article.readTime}</span>
                </div>
                
                <h3 className="blog-card-title">
                  <Link to={`/blog/${article.id}`}>
                    {article.title}
                  </Link>
                </h3>
                
                <p className="blog-excerpt">{article.excerpt}</p>
                
                <div className="blog-footer">
                  <span className="blog-date">{article.date}</span>
                  <Link to={`/blog/${article.id}`} className="blog-read-link">
                    Read Article &rarr;
                  </Link>
                </div>
              </div>
            </article>
          ))}
        </div>

        {/* View All Articles Action */}
        <div className="text-center" style={{ marginTop: '4.8rem' }}>
          <Link to="/blog" className="btn btn-outline">
            Explore All Blog Articles &rarr;
          </Link>
        </div>
      </div>
    </section>
  );
}
